var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18451)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18451)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.0013,
    height: 40.0013,
    rx: 20.0007,
    fill: "#CCCEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6115,
    y: 20.9452,
    width: 12.6671,
    height: 3.22233,
    rx: 1.61117,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333345
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10487_18451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.88975,
    y: 33.6525,
    width: 24.1119,
    height: 25.5564,
    rx: 12.056,
    transform: "rotate(-16 4.88975 33.6525)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333345
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3895,
    y: 27.0564,
    width: 6.778,
    height: 3.22233,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333345
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5562,
    y: 26.8898,
    width: 6.44466,
    height: 4.44459,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8338,
    y: 12.5004,
    width: 10.2226,
    height: 16.1117,
    rx: 5.11128,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333345
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-1_10487_18451",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8748 31.2232C25.6563 32.9527 23.085 34.3176 19.9452 34.3176C16.8236 34.3176 14.2639 32.9684 14.0196 31.2532C9.83829 32.4507 6.77808 36.3021 6.77808 40.8682V48.424H33.2234V40.8682C33.2234 36.2632 30.1109 32.3852 25.8748 31.2232Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8748 31.2232C25.6563 32.9527 23.085 34.3176 19.9452 34.3176C16.8236 34.3176 14.2639 32.9684 14.0196 31.2532C9.83829 32.4507 6.77808 36.3021 6.77808 40.8682V48.424H33.2234V40.8682C33.2234 36.2632 30.1109 32.3852 25.8748 31.2232Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8748 31.2232L25.963 30.9017L25.5923 30.8L25.5441 31.1814L25.8748 31.2232ZM14.0196 31.2532L14.3496 31.2062L14.2957 30.8274L13.9278 30.9328L14.0196 31.2532ZM6.77808 48.424H6.44473V48.7573H6.77808V48.424ZM33.2234 48.424V48.7573H33.5568V48.424H33.2234ZM25.5441 31.1814C25.4545 31.8907 24.8685 32.5898 23.8506 33.1238C22.8433 33.6522 21.4704 33.9843 19.9452 33.9843V34.651C21.5598 34.651 23.0424 34.3006 24.1603 33.7142C25.2677 33.1333 26.0766 32.2852 26.2055 31.265L25.5441 31.1814ZM19.9452 33.9843C18.4289 33.9843 17.063 33.656 16.0572 33.1329C15.041 32.6043 14.45 31.9109 14.3496 31.2062L13.6896 31.3002C13.8335 32.3107 14.6445 33.1496 15.7496 33.7244C16.8651 34.3046 18.3398 34.651 19.9452 34.651V33.9843ZM7.11142 40.8682C7.11142 36.4548 10.0693 32.7313 14.1114 31.5737L13.9278 30.9328C9.60732 32.1701 6.44473 36.1494 6.44473 40.8682H7.11142ZM7.11142 48.424V40.8682H6.44473V48.424H7.11142ZM33.2234 48.0906H6.77808V48.7573H33.2234V48.0906ZM32.8901 40.8682V48.424H33.5568V40.8682H32.8901ZM25.7866 31.5447C29.8816 32.668 32.8901 36.4172 32.8901 40.8682H33.5568C33.5568 36.1092 30.3401 32.1024 25.963 30.9017L25.7866 31.5447Z",
    fill: "#111111",
    mask: "url(#path-10-inside-1_10487_18451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0185 17.7554C26.0185 13.4607 23.6493 10.5559 20.7636 10.5559C17.0665 10.5559 13.2998 11.9427 13.2998 18.5003C13.2998 20.1227 13.4207 21.3318 14.3893 22.223C14.5004 22.3252 14.7857 22.5481 14.7337 22.4586C14.5459 20.7053 15.9065 19.8171 17.9449 18.5003C19.027 17.8012 21.2784 16.5006 22.1117 15.8339C22.7352 16.1872 23.9854 17.1912 24.3346 17.7897C24.5218 18.1107 24.8225 19.2108 25.028 20.4949C25.6998 19.688 26.0185 18.8806 26.0185 17.7554Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.426898
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5696 15.3156C22.4257 14.5394 23.7063 12.7679 23.6242 11.6174",
    stroke: "#111111",
    strokeWidth: 0.426898
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5013,
    height: 38.5013,
    rx: 19.2507,
    stroke: "white",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.0013,
    height: 40.0013,
    rx: 20.0007,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10487_18451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4453,
    height: 35.5568,
    fill: "white",
    transform: "translate(7.77808 2.66675)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric11);
export default __webpack_public_path__ + "static/media/Generic 11.15653dcacfe9ffa6264386ca845d3163.svg";
export { ForwardRef as ReactComponent };